import React, { createRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Card, Tooltip, Typography } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'

import { attributesNames, colorTypes, userRightTypes, scopeTypes } from '../../../../constants'
import { DebugView, Logger, LoggerTypes } from '../../../../utils'
import { DialogDelete, AccessControl } from '../../../../components'
import { AttributeVariableDialogUpdate } from '../dialogs'
import '../../style-common-card.scss'

export const AttributeVariableCard = ({
  currentProject,
  currentScenario,
  variable,
  actionDispatchUpdate,
  actionDispatchDelete
}) => {
  const { t } = useTranslation()
  const ref = createRef()

  const [openDialogUpdate, setOpenDialogUpdate] = useState(false)
  const [openDialogDelete, setOpenDialogDelete] = useState(false)

  const onDialogUpdateOpen = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeVariableCard.onOpenDialog()')
    setOpenDialogUpdate(true)
  }

  const onDialogDeleteOpen = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeVariableCard.onOpenDialogDelete()')
    setOpenDialogDelete(true)
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeVariableCard.render()', { currentProject, currentScenario, variable })

  return (
    currentProject && (
      <Card className="common-card">
        <div className="common-card-header">
          <Typography className="common-card-header-name" variant="subtitle2" color={colorTypes.PRIMARY}>
            <span style={{ marginRight: '10px' }}>{variable.name}</span>
            <b>
              {variable.initial_value} {variable.unit}
            </b>
          </Typography>
          <div className="common-card-header-icon">
            {/* -- Button EDIT -- */}
            <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
              {actionDispatchUpdate && (
                <Tooltip ref={ref} title={t('common.update')}>
                  <ModeEditOutlineOutlinedIcon
                    onClick={onDialogUpdateOpen}
                    color={colorTypes.PRIMARY}
                    className="buttons-edit-icon"
                  />
                </Tooltip>
              )}
            </AccessControl>

            {/* -- Button DELETE -- */}
            <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_DELETE]} renderNoAccess={() => <></>}>
              {actionDispatchDelete && (
                <Tooltip ref={ref} title={t('common.delete')}>
                  <DeleteOutlineIcon
                    onClick={onDialogDeleteOpen}
                    color={colorTypes.PRIMARY}
                    className="buttons-edit-icon"
                  />
                </Tooltip>
              )}
            </AccessControl>

            {openDialogUpdate && (
              <AttributeVariableDialogUpdate
                currentProject={currentProject}
                currentScenario={currentScenario}
                actionUpdateDispatch={actionDispatchUpdate}
                openDialog={openDialogUpdate}
                setOpenDialog={setOpenDialogUpdate}
                variable={variable}
              />
            )}
            {openDialogDelete && (
              <DialogDelete
                title={t('attributes.variables.delete.title')}
                message={t('attributes.variables.delete.description')}
                projectId={currentProject?.id}
                scenarioId={currentScenario?.id}
                actionDispatchDelete={actionDispatchDelete}
                openDialog={openDialogDelete}
                setOpenDialog={setOpenDialogDelete}
                variable={variable}
              />
            )}
          </div>
        </div>
        {variable.scope === scopeTypes.IMPORT ? <div className="importGlobal">{t('global.title')}</div> : ''}
        <div className="common-card-description">{variable.description}</div>
        <div className="common-card-list"></div>
        <DebugView type={attributesNames.VARIABLES}>{variable}</DebugView>
      </Card>
    )
  )
}

AttributeVariableCard.displayName = 'AttributeVariableCard'

AttributeVariableCard.propTypes = {
  variable: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    initial_value: PropTypes.number,
    unit: PropTypes.string,
    scope: PropTypes.string
  }).isRequired,
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  actionDispatchUpdate: PropTypes.func,
  actionDispatchDelete: PropTypes.func
}

AttributeVariableCard.defaultProps = {
  variable: null,
  currentProject: null,
  currentScenario: null,
  actionDispatchUpdate: null,
  actionDispatchDelete: null
}
